const validDomains = [
    "eduranga.pl",
    "htaal.nl",
    "juniorcloud.nl",
    "liber.se",
    "plantyn.com",
    "noordhoff.nl",
    "scoodle.be",
];
export function getIconBaseUrl() {
    if (typeof window !== "undefined" && validDomains.some((domain) => window.location.hostname.endsWith(domain))) {
        return "/pixel";
    }
    return "https://pixel.infinicloud.app";
}
//# sourceMappingURL=iconBaseUrl.js.map